// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/mutation-remove-question.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Leads_Content_Content_Questions_Content_Editor($id: uuid!) {
  delete_leads_questions_by_pk(id: $id) {
    id
  }
}

`